import * as React from 'react'

import { TableProvider } from '@/modules/drivers/context/TableContext'
import { RouteComponentProps } from '@/app/navigation/withRouter'
import BillingBasicActionBar from '../components/BillingBasicActionBar'
import BillingDriversTable from '../components/BillingDriversTable'
import BillingSummaryFooter from '../components/BillingSummaryFooter'
import BillingPeriodPicker from '../components/BillingPeriodPicker'
import type { BillingPeriod } from '../types'
import { FaIcon, faReceiptSolid } from '@/lib/fa'

interface BillingPerCompanyPageRouteParams {
  companyId: string
}

const currentPeriod = (): BillingPeriod => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

const InnerPanel: React.FC<{
  companyId: string
  period: BillingPeriod
}> = ({ companyId, period }) => {
  return (
    <>
      <div className="tw-relative tw-bg-content-primary">
        <BillingBasicActionBar />
      </div>
      <div className="tw-z-10 tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden">
        <BillingDriversTable companyId={companyId} period={period} />
      </div>
      <BillingSummaryFooter companyId={companyId} period={period} />
    </>
  )
}

export const BillingPerCompanyPage: React.FC<
  RouteComponentProps<BillingPerCompanyPageRouteParams>
> = ({ match }) => {
  const { companyId } = match.params
  const cid = companyId
  const [period, setPeriod] = React.useState<BillingPeriod>(currentPeriod())

  return (
    <div className="tw-flex tw-h-full tw-flex-col">
      {/* <div className="tw-flex tw-flex-col tw-items-start tw-gap-4 tw-border-b tw-p-4 md:tw-flex-row md:tw-items-center">
        <CompanyNameBadge />
        <BillingPeriodPicker period={period} onChangePeriod={setPeriod} />
      </div> */}
      <div className="tw-items-left tw-flex tw-justify-between tw-gap-6 tw-rounded-t-xl tw-border-b tw-p-4">
        <div className="tw-flex tw-items-center tw-gap-4">
          <div className="tw-flex tw-items-center tw-rounded-t-xl">
           <FaIcon icon={faReceiptSolid} className='tw-mr-1'/>
            <div className="tw-flex-1 tw-text-xl tw-font-semibold">Rozliczenia</div>
          </div>
        </div>
        <div className="tw-flex tw-items-center tw-gap-3">
         
           <BillingPeriodPicker period={period} onChangePeriod={setPeriod} />
        </div>
      </div>
      <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">
        <TableProvider bulk={true}>
          <InnerPanel companyId={cid} period={period} />
        </TableProvider>
      </div>
    </div>
  )
}
